import { OAUTH_CSRF_COOKIE_NAME, OAUTH_CSRF_NONCE_MAX_AGE_MS } from "@shared/const";

export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

// Generate login URL at runtime so redirect URI reflects the current origin.
//
// Also mints a random CSRF nonce, embeds it in `state`, and stores it in a
// short-lived cookie only this origin can set (see #83). The callback
// handler verifies the two match before establishing a session. This is a
// standard "double-submit cookie" CSRF defense — it doesn't require a
// server round-trip before redirecting (this app has no session store to
// bind a server-issued nonce to ahead of time), but provides the same
// guarantee: an attacker on another origin cannot set this cookie on the
// victim's browser, and a high-entropy crypto.randomUUID() value can't be
// guessed.
export const getLoginUrl = () => {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  const redirectUri = `${window.location.origin}/api/oauth/callback`;
  const nonce = crypto.randomUUID();
  const state = btoa(JSON.stringify({ redirectUri, nonce }));

  const cookieAttributes = [
    `${OAUTH_CSRF_COOKIE_NAME}=${nonce}`,
    "Path=/",
    `Max-Age=${Math.floor(OAUTH_CSRF_NONCE_MAX_AGE_MS / 1000)}`,
    "SameSite=Lax",
  ];
  if (window.location.protocol === "https:") cookieAttributes.push("Secure");
  document.cookie = cookieAttributes.join("; ");

  const url = new URL(`${oauthPortalUrl}/app-auth`);
  url.searchParams.set("appId", appId);
  url.searchParams.set("redirectUri", redirectUri);
  url.searchParams.set("state", state);
  url.searchParams.set("type", "signIn");

  return url.toString();
};
